<template>
  <div>
    <Head :title="form.title" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/shopifyLocations">Shopify Locations</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.title }}
    </h1>
    <div class="max-w-4xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.store_id" :error="form.errors.store_id" class="pb-8 pr-6 w-full" label="Store Id" />
          <text-input v-model="form.location_id" :error="form.errors.location_id" class="pb-8 pr-6 opacity-80 w-full" label="Location Id" disabled />
          <text-input v-model="form.shop_domain" :error="form.errors.shop_domain" class="pb-8 pr-6 opacity-80 w-full" label="Shop Domain" disabled />
          <text-input v-model="form.location_name" :error="form.errors.location_name" class="pb-8 opacity-80 pr-6 w-full" label="Location Name" disabled />
          <text-input v-model="form.street" :error="form.errors.street" class="pb-8 pr-6 opacity-80 w-full lg:w-1/2" label="Street" disabled />
          <text-input v-model="form.apartment" :error="form.errors.apartment" class="pb-8 pr-6 opacity-80 w-full lg:w-1/2" label="Apartment" disabled />
          <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 opacity-80 w-full lg:w-1/2" label="City" disabled />
          <text-input v-model="form.country" :error="form.errors.country" class="pb-8 pr-6 opacity-80 w-full lg:w-1/2" label="Country" disabled />
          <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="pb-8 pr-6 opacity-80 w-full lg:w-1/2" label="Postal Code" disabled />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 opacity-80 w-full lg:w-1/2" label="Phone" disabled />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Shopify Location</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    shopifyLocation: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        location_id: this.shopifyLocation.location_id,
        store_id: this.shopifyLocation.store_id,
        shop_domain: this.shopifyLocation.shop_domain,
        location_name: this.shopifyLocation.location_name,
        apartment: this.shopifyLocation.apartment,
        street: this.shopifyLocation.street,
        city: this.shopifyLocation.city,
        country: this.shopifyLocation.country,
        postal_code: this.shopifyLocation.postal_code,
        phone: this.shopifyLocation.phone,
      }),
    }
  },
  
  methods: {
    update() {
      this.form.put(`/shopifyLocations/${this.shopifyLocation.id}`)
    },
  },
}
</script>
